import request from 'services/request';
import { paramsSerializer } from 'RootModule/services/catalogs';

export async function AccountStatusConsult({ cancelToken, params }) {
  let uri = '/AccountStatement/Api/v1/Statements';
  return request(uri, {
    method: 'GET',
    cancelToken,
    params,
    paramsSerializer,
  });
}
